<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">月度免费报告</div>
          <span class="m-title-s">月度免费报告操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>当前免费报告
            <!--            <span style="font-size: 14px;margin-left: 20px;color: #ff4d51;">(热门报告取列表最新创建的前3项显示在app内)</span>-->
          </div>
          <div class="m-table-btn">
            <el-button @click="openPopup" type="primary" size="">新增免费报告</el-button>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border size="small">
          <el-table-column prop="title" label="标题" width=""></el-table-column>
          <el-table-column prop="homeOptionName" label="所属栏目" width=""></el-table-column>
          <el-table-column prop="createDate" label="创建时间" align="center"></el-table-column>
        </el-table>
        <div>
          <div class="m-table-title" style="margin-bottom: 5px;">
            <i class="el-icon-s-order"></i>历史免费
          </div>
          <el-table :data="historyList" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border size="small">
            <el-table-column prop="title" label="标题" width=""></el-table-column>
            <el-table-column prop="homeOptionName" label="所属栏目" width=""></el-table-column>
            <el-table-column prop="createDate" label="创建时间" align="center"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog title="更换热门" :visible.sync="openState" @close='closeDialog' width="750px" center :close-on-click-modal="false">
      <div class="m-open-container">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="125px">
            <el-form-item label="选择热门报告: " prop="title">
              <el-input v-model="form.title" :id="form.articleId" placeholder="点击右侧按钮" disabled>
                <el-button type="primary" slot="append"  @click="tree = true">选择上级菜单</el-button>
              </el-input>
            </el-form-item>
            <el-form-item label="取消热门报告: " prop="removeArticleId">
              <el-select v-model="form.removeArticleId" placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in list" :key="item.id" :label="item.title + '--->' + item.homeOptionName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;" v-loading="formLoading">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
      <!-- 选择树 -->
      <el-dialog width="600px" title="请选择上级菜单" :visible.sync="tree" center append-to-body>
        <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
        <el-tree
          class="filter-tree"
          :data="dataListOpt"
          :props="defaultProps"
          node-key="id"
          default-expand-all
          :filter-node-method="filterNode">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <el-button type="text" size="mini" :name="node.label" :value="data.id" @click="selectMenu">选择</el-button>
            </span>
          </span>
        </el-tree>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'articleFree',
  data () {
    return {
      openText: '新增',
      openState: false,
      formLoading: false,
      isLoading: true,
      list: [],
      historyList: [],
      form: {
        articleId: '',
        removeArticleId: '',
        title: ''
      },
      tree: false,
      filterText: '',
      dataListOpt: [],
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      rules: {
        title: [
          { required: true, message: '请选择报告分类', trigger: 'blur' }
        ],
        removeArticleId: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true
      return data.title.indexOf(value) !== -1
    },
    selectMenu (e) {
      for (let i = 0; i < this.list.length; i++) {
        if (e.target.parentElement.value === this.list[i].id) {
          return this.$message.error('当前报告已在热门中，请选择其它报告。')
        }
      }
      this.tree = false
      this.form.title = e.target.parentElement.name
      this.form.articleId = e.target.parentElement.value
    },
    closeDialog: function () {
      this.form = {
        articleId: '',
        removeArticleId: '',
        title: ''
      }
      this.openText = '新增'
      this.openState = false
      this.formLoading = false
    },
    openPopup () {
      this.openState = true
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.formLoading = true
          this.$axios.post('/free/save', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.openState = false
                _this.listData()
                _this.historyListData()
              } else {
                _this.$message.error(res.msg)
              }
              _this.formLoading = false
            })
        } else {
          return false
        }
      })
    },
    // 报告列表
    loadArticleList () {
      let _this = this
      this.$axios.post('/article/list')
        .then((res) => {
          _this.dataListOpt = res.data
        })
    },
    // 列表
    listData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/free/list')
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    },
    // 管理员列表
    historyListData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/free/historyList')
        .then((res) => {
          _this.historyList = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.listData()
    this.historyListData()
    this.loadArticleList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/article/ArticleFree.vue